const productPageCarousels = () => {
  // const ingredients = document.getElementsByClassName('product-ingredients')

  $(function () {

    const $slider = $('.product-ingredients');
    const itemCount = $slider.children().length;

    if (itemCount >= 3) {
      $slider.slick({
        dots: false,
        infinite: false,
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow'),
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          }
        ]
      });
    } else if (itemCount === 2) {
      document.querySelector('.product-ingredients').style.justifyContent = "space-between";
      document.querySelector('.product-ingredients__arrows').style.display = "none";

      const ingredients = document.querySelectorAll('.product-ingredient');

      ingredients.forEach(ingredient => {
        ingredient.style.display = "flex";
        ingredient.style.width = "48%";
      });

    } else {
      document.querySelector('.product-ingredients__arrows').style.display = "none";
    }
  });

  $('.professional-proof__people').slick({
    dots: false,
    infinite: false,
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $('.prev-arrow--pp'),
    nextArrow: $('.next-arrow--pp'),
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.company-proof').slick({
    dots: false,
    infinite: false,
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $('.prev-arrow--cp'),
    nextArrow: $('.next-arrow--cp'),
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

};

export default productPageCarousels;